export default "__VITE_ASSET__d142dfb1__"